import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import papas from "../views/theonlineTest/published/index.vue";
import { listResourceTree } from "@/api/permissions.js";
import menu from "./routerList";
Vue.use(VueRouter);

let routes = [
  // 登录
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: 'login' */ "@/views/login/index")
  },
  {
    // 安卓跳转H5查看资讯
    path: "/news/:id",
    meta: {
      title: "新闻咨询"
    },
    component: () => import("../components/xxyApp/news.vue")
  },
  {
    // 安卓跳转H5查看轮播
    path: "/shuffling/:id",
    meta: {
      title: "轮播"
    },
    component: () => import("../components/xxyApp/shuffling.vue")
  },
  {
    // 安卓跳转H5查看开屏
    path: "/theTail/:id",
    meta: {
      title: "开屏"
    },
    component: () => import("../components/xxyApp/theTail.vue")
  },
  {
    // 旧版运营平台埋点统计
    path: "/visualization",
    meta: {
      title: "埋点统计"
    },
    component: () => import("../components/xxyApp/visualization.vue")
  },
  // 注册
  {
    path: "/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: 'register' */ "@/views/register/index")
  },
  // 修改密码
  {
    path: "/passwrod",
    name: "passwrod ",
    component: () =>
      import(/* webpackChunkName: 'forget' */ "../views/forget/indexs.vue")
  },
  // 忘记密码
  {
    path: "/forget",
    name: "forget",
    component: () =>
      import(/* webpackChunkName: 'forget' */ "@/views/forget/index")
  },
  // 首页
  {
    path: "/",
    name:'Home',
    component: () =>
      import(/* webpackChunkName: 'layout' */ "@/views/layout/index"),
    meta: { requiresAuth: true },
    redirect: { name: "Papers" },
    children: [
      // {
      //   path: "papers",
      //   name: "Papers",
      //   component: () => import("../views/theonlineTest/published/index.vue"),
      //   meta: ["发布试卷"],
      // },
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index")
      },
      {
        name: "",
        path: "",
        meta: ["在线考试"],
        component: { render: e => e("router-view") },
        redirect: { name: "Papers" },
        children: [
          {
            path: "papers",
            name: "Papers",
            component: () =>
              import("../views/theonlineTest/published/index.vue"),
            meta: ["发布试卷"]
          },
          // 在线考试批改试卷
          {
            path: "correcting",
            name: "Correcting",
            component: () =>
              import("../views/theonlineTest/correcting/index.vue"),
            meta: ["批改试卷"]
          },
          // 在线考试考试监控
          {
            path: "monitoring",
            name: "Monitoring",
            component: () =>
              import("../views/theonlineTest/monitoring/index.vue"),
            meta: ["考试监控"]
          }
        ]
      },
      {
        name: "",
        path: "",
        meta: ["在线练习"],
        component: { render: e => e("router-view") },
        children: [
          {
            path: "testpapers",
            name: "Testpapers",
            component: () => import("../views/onlinetestpaper/index.vue"),
            meta: ["发布练习"]
          },
          {
            path: "practiceWatch",
            name: "PracticeWatch",
            component: () => import("../views/monitoring/index.vue"),
            meta: ["练习监控"]
          },
          {
            path: "exerciseState",
            name: "ExerciseState",
            component: () => import("../views/exerciseState/page.vue"),
            meta: ["每日练习情况"]
          }
        ]
      },
      // 5.29 迁移培训操作考核
      {
        name: "",
        path: "",
        meta: ["临床技能考核"],
        component: { render: e => e("router-view") },
        children: [
          {
            path: "releaseCheck",
            name: "ReleaseCheck",
            component: () =>
              import("../views/operationCheck/releaseCheck/index.vue"),
            meta: ["发布操作考核"]
          },
          {
            // 添加考核
            path: "/operationCheck/releaseCheck/addCheck",
            name: "addCheck",
            component: () =>
              import(
                "../views/operationCheck/releaseCheck/components/AddCheck.vue"
              ),
            meta: ["发布操作考核"]
          },
          {
            path: "operationScore",
            name: "OperationScore",
            component: () =>
              import("../views/operationCheck/operationScore/index.vue"),
            meta: ["操作考核评分"]
          },
          // 评分管理
          {
            path: "/operationScore/editorScore",
            name: "EditorOperationScore",
            component: () =>
              import(
                "../views/operationCheck/operationScore/components/editorScore.vue"
              ),
            meta: ["操作考核评分"]
          },
          {
            path: "/operationScore/addExaminee", // 添加考生
            name: "addExamOperationScore",
            component: () =>
              import(
                "../views/operationCheck/operationScore/components/AddExaminee.vue"
              ),
            meta: ["操作考核评分"]
          },
          {
            path: "/operationScore/addTeacher", // 添加操作考核评分
            name: "addExamTeacher",
            meta: { name: "操作考核评分" },
            component: () =>
              import(
                "../views/operationCheck/operationScore/components/AddTeacher"
              )
          },
          {
            path: "/operationCheck/scoreTable",
            name: "ScoreTable",
            component: () =>
              import("../views/operationCheck/scoreTable/index.vue"),
            meta: ["评分表管理"]
          },
          {
            // 添加评分表管理
            path: "/scoreTable/addTable",
            name: "ScoreTable",
            component: () =>
              import(
                "../views/operationCheck/scoreTable/components/AddTable.vue"
              ),
            meta: ["评分表管理"]
          }
        ]
      },
      {
        name: "",
        path: "",
        meta: ["视频学习任务"],
        component: { render: e => e("router-view") },
        children: [
          {
            path: "videoTask",
            name: "VideoTask",
            component: () => import("../views/videoTask/index.vue"),
            meta: ["视频学习任务"]
          }
        ]
      },
      {
        name: "",
        path: "",
        meta: ["纸质试卷"],
        component: { render: e => e("router-view") },
        children: [
          // 纸质试卷，试卷列表
          {
            path: "paperlist",
            name: "Paperlist",
            component: () => import("../views/paper_test/index.vue"),
            meta: ["纸质试卷库"]
          }
        ]
      },
      {
        name: "",
        path: "",
        meta: ["考生管理"],
        component: { render: e => e("router-view") },
        children: [
          // 考生管理-考生列表
          {
            path: "candidateList",
            name: "candidateList",
            component: () => import("@/views/examinee/candidateList/index.vue"),
            meta: ["考生列表"]
          },
          // 考生管理-考生组列表
          {
            path: "ListOfGroups",
            name: "ListOfGroups",
            component: () => import("@/views/examinee/ListOfGroups/index.vue"),
            meta: ["考生组列表"]
          },
          // 考生管理-审核考生列表
          {
            path: "ReviewList",
            name: "ReviewList",
            component: () => import("@/views/examinee/ReviewList/index.vue"),
            meta: ["审核考生列表"]
          }
        ]
      },
      {
        name: "",
        path: "",
        meta: ["科室管理"],
        component: { render: e => e("router-view") },
        children: [
          // 科室管理-科室列表
          {
            path: "departList",
            name: "departList",
            component: () => import("@/views/depart/index.vue"),
            meta: ["科室列表"]
          }
        ]
      },
      // {
      //   name: "",
      //   path: "",
      //   meta: ["培训任务"],
      //   component: { render: e => e("router-view") },
      //   children: [
      //     {
      //       path: "manage",
      //       name: "Manage",
      //       component: () => import("@/views/taskTraining/manage/index.vue"),
      //       meta: ["任务管理"],
      //     },
      //     {
      //       path: "situation",
      //       name: "Situation",
      //       component: () => import("@/views/taskTraining/situation/index.vue"),
      //       meta: ["培训情况"]
      //     }
      //   ]
      // },
      {
        name: "",
        path: "",
        meta: ["公告管理"],
        component: { render: e => e("router-view") },
        children: [
          // 公告管理-公告列表
          {
            path: "notice",
            name: "notice",
            component: () => import("@/views/notice/index.vue"),
            meta: ["公告列表"]
          }
        ]
      },
      {
        name: "",
        path: "",
        meta: ["资源管理"],
        component: { render: e => e("router-view") },
        children: [
          //资源管理
          {
            path: "/resources",
            name: "Resources",
            component: () => import("@/views/resources/courseware/index"),
            meta: ["课件管理"]
          },
          //资源管理
          {
            path: "/videoresources",
            name: "Videoresources",
            component: () => import("@/views/resources/videoware/index"),
            meta: ["视频管理"]
          }
        ]
      },
      // 题库管理
      {
        path: "/question_bank",
        meta: ["题库管理"],
        redirect: "/question_bank/platform",
        component: () => import("../views/question_bank/index.vue"),
        children: [
          // {
          //   path: "platform",
          //   name: "Platform",
          //   meta: ["平台题库"],
          //   component: () =>
          //     import(
          //       "../views/question_bank/platform/index.vue"
          //     )
          // },
          {
            path: "custom",
            name: "Custom",
            meta: ["自定义平台题库"],
            component: () => import("../views/question_bank/custom/index.vue")
          },
          {
            path: "collect",
            name: "Collect",
            meta: ["收藏题库"],
            component: () => import("../views/question_bank/collect/index.vue")
          }
        ]
      },
      // 管理员管理
      {
        path: "/administrator",
        meta: ["管理员管理"],
        redirect: "/administrator/personnel",
        component: () => import("../views/administrator/index.vue"),
        children: [
          {
            path: "personnel",
            name: "Personnel",
            meta: ["人员管理"],
            component: () =>
              import("../views/administrator/personnel/index.vue")
          }
          // {
          //   path: "rolemanag",
          //   name: "Rolemanag",
          //   meta: ["角色管理"],
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "about" */ "../views/administrator/rolemanag/index.vue"
          //     )
          // },
          // {
          //   path: "operationlog",
          //   name: "OperationLog",
          //   meta: ["操作日志"],
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "about" */ "../views/administrator/operationlog/index.vue"
          //     )
          // }
        ]
      },
      //个人中心
      {
        path: "/user_center",
        meta: ["个人中心"],
        // 重定向，决定默认跳转那个路由
        redirect: "/user_center/basis",
        component: () => import("../views/user_center/index.vue"),
        children: [
          {
            path: "basis",
            name: "Basis",
            meta: ["基本信息"],
            component: () => import("../views/user_center/basis/page.vue")
          },
          {
            path: "modifyThe",
            name: "ModifyThe",
            meta: ["独立密码"],
            component: () =>
              import("../views/user_center/IndependentPaw/index.vue")
          },
          {
            path: "setEncy",
            name: "SetEncy",
            meta: ["独立密码"],
            component: () =>
              import(
                "../views/user_center/IndependentPaw/components/setEncryption.vue"
              )
          },
          {
            path: "decryTable",
            name: "DecryTable",
            meta: ["独立密码"],
            component: () =>
              import(
                "../views/user_center/IndependentPaw/components/decryTable.vue"
              )
          },
          {
            path: "landingpaw",
            name: "Landingpaw",
            meta: ["登陆密码"],
            component: () => import("../views/user_center/landing/page.vue")
          },
          {
            path: "feedback",
            name: "Feedback",
            meta: ["用户反馈"],
            component: () => import("../views/user_center/feedback/page.vue")
          },
          {
            path: "alerts",
            name: "Alerts",
            meta: ["消息通知"],
            component: () =>
              import(
                /* webpackChunkName: "about" */ "../views/user_center/alerts/index.vue"
              )
          }
          // {
          //   path: "subjects",
          //   name: "Subjects",
          //   meta: ["开通科目"],
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "about" */ "../views/user_center/subjects/page.vue"
          //     )
          // }
        ]
      },
      // 线下培训
      // {
      //   name: "",
      //   path: "",
      //   meta: ["线下培训"],
      //   component: { render: e => e("router-view") },
      //   children: [
      //     // 在线考试发布试卷 余**
      //     {
      //       path: "training",
      //       name: "Training",
      //       component: () => import("../views/training/index.vue"),
      //       meta: ["线下培训"]
      //     }
      //   ]
      // },
      {
        name: "",
        path: "",
        meta: ["调查问卷"],
        component: { render: e => e("router-view") },
        children: [
          // 在线考试发布试卷 余**
          {
            path: "answer",
            name: "Answer",
            component: () => import("../views/answerExam/index.vue"),
            meta: ["调查问卷"]
          }
        ]
      }
    ]
  },
  {
    path: "/LivePlayer",
    name: "liveplayer",
    component: () => import("@/views/LivePlayer/index")
  },
  {
    path: "/examination",
    name: "Examination",
    meta: { name: "在线考试" },
    redirect: "/examination/table",
    component: () => import("@/views/examination/page"),
    children: [
      {
        path: "/examination/table",
        meta: { name: "列表" },
        name: "ExamPage",
        component: () => import("@/views/examination/components/Table")
      },
      {
        path: "/examination/addExam",
        meta: { name: "考前信息" },
        name: "ExamAdd",
        component: () => import("@/views/examination/components/addExam")
      },
      {
        path: "/examination/Answer",
        meta: { name: "答题卡" },
        name: "ExamAnswer",
        component: () => import("@/views/examination/components/Answer")
      }
    ]
  },
  {
    path: "/videoData",
    name: "videoData",
    meta: { name: "视频资料" },
    redirect: "/videoData/page",
    component: () => import("@/views/examination/page"),
    children: [
      {
        path: "/videoData/page",
        meta: { name: "列表" },
        name: "VideoDataPage",
        component: () => import("@/views/examination/components/index")
      }
    ]
  },
  {
    path: "/studentPort",
    name: "studentPort",
    meta: { name: "参加练习" },
    redirect: "/studentPort/page",
    component: () => import("@/views/examination/page"),
    children: [
      {
        path: "/studentPort/page",
        meta: { name: "列表" },
        name: "StudentPortPage",
        component: () => import("@/views/studentPort/index")
      }
    ]
  },
  {
    path: "*",
    name: "error-page",
    component: () => import("@/views/error-page/index")
  }
];
let pm;
const router = new VueRouter({
  mode: "hash",
  routes
});
const original = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return original.call(this, location).catch(err => err);
};
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
function addDynamicRoutes() {
  if (localStorage.getItem("hid") && localStorage.getItem("hid") == "4035") {
    // 目前只针对4035医院开放
    // router.addRoutes(menu);
    menu.forEach(item=>{
      router.addRoute('Home', item) // 'Home' 是父路由的名称
    })
  }
}
const createRouter = () => new VueRouter({
  mode: "hash",
  routes // 关键：这里只包含你的静态路由，不包含任何动态添加的路由
})
export function resetRouter() {
  const newRouter = createRouter() // 获取一个全新的、只包含静态路由的路由器实例
  router.matcher = newRouter.matcher // 关键：替换当前路由器的匹配器[1,2](@ref)
  console.log('路由已重置')
}
// 导航守卫
router.beforeEach((to, from, next) => {
  // 验证 to 路由是否需要进行身份认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.userlist || store.state.userlist === "null") {
      // 未登录，跳转到登录页
      return next({
        name: "login",
        query: {
          // 将本次路由的 fullPath 传递给 login 页面.
          redirect: to.fullPath
        }
      });
    }
    // 已经登录，允许通过
    // addDynamicRoutes();
    next();
  } else {
    next();
  }
});

pm = new Promise((resolve, reject) => {
  resolve("123");
}).then(() => {
  return new Promise((resolve, reject) => {
    resolve(router);
  });
});
// }
export { pm, addDynamicRoutes,};
